// src/App.tsx
import { ConfigProvider } from 'antd';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import TeamPage from './pages/TeamPage';
import ContactPage from './pages/ContactPage';
import Header from './components/Header';
import './styles/index.css';
import { HelmetProvider } from 'react-helmet-async';
import './i18n';

const App = () => {

  return (
    <HelmetProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#5B8FC6',
            colorLink: '#5B8FC6',
            colorBgBase: '#F6F9FB',
            colorText: '#3A4256',
            colorTextSecondary: '#6B7280',
            borderRadius: 12,
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "PingFang SC", "Microsoft YaHei", sans-serif',
          },
          components: {
            Card: {
              boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              borderRadiusLG: 16,
            },
            Button: {
              borderRadius: 20,
            },
          },
        }}
      >
        <BrowserRouter>
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </BrowserRouter>
      </ConfigProvider>
    </HelmetProvider>
  );
};

export default App;

